import axios from "axios";
import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";

import Responsive from "semantic-ui-react/dist/commonjs/addons/Responsive";
import Form from "semantic-ui-react/dist/commonjs/collections/Form";
import Grid from "semantic-ui-react/dist/commonjs/collections/Grid";
import Button from "semantic-ui-react/dist/commonjs/elements/Button";
import Divider from "semantic-ui-react/dist/commonjs/elements/Divider";
import Header from "semantic-ui-react/dist/commonjs/elements/Header";
import Icon from "semantic-ui-react/dist/commonjs/elements/Icon/Icon";
import { HeaderMenu } from "../../components/HeaderMenu";
import { LayoutProps } from "../../components/LayoutWrapper";
import { ResponsiveElement } from "../../components/ResponsiveElement";
import { SwitchSelect } from "../../components/SwitchSelect";
import { Helpers } from "../../utils/helpers";
import { PropertyPartition } from "../Properties/types/property";

interface AddPropertyPartitionState {
    propertyData: PropertyPartition;
    loaded: boolean;
    savingData: boolean;
    redirect: boolean;
}

interface PropertyProps extends LayoutProps {
    match: any;
}

export const fellingTypes = [{
    id: "kailcirte",
    label: "Kailcirte",
}, {
    id: "izlases_cirte",
    label: "Izlases cirte",
}, {
    id: "kopsanas_cirte",
    label: "Kopšanas cirte",
}, {
    id: "caurmera_cirte",
    label: "Caurmēra cirte",
}, {
    id: "iespejama_cuarmera_cirte",
    label: "Iespējama caurmēra cirte",
}, {
    id: "nevar_cirst",
    label: "Nevar cirst",
}];

export const wetReasons = [{
    id: "pruvs",
    label: "Purvs",
}, {
    id: "tuvuma_upe",
    label: "Tuvumā upe",
}, {
    id: "tuvuma_ezers",
    label: "Tuvumā ezers",
}, {
    id: "bebri",
    label: "Bebri",
}, {
    id: "cits",
    label: "Cits",
}];

export const taxationReason = [{
    id: "valdosa_suga",
    label: "Valdošā suga",
}, {
    id: "koku_vecums",
    label: "Koku vecums",
}, {
    id: "viss_izcirsts",
    label: "Viss izcirsts",
}, {
    id: "daleji_izcirsts",
    label: "Daļēji izcirsts",
}, {
    id: "cits",
    label: "Cits",
}];

export const drought = [{
    id: "sauss",
    label: "Sauss",
}, {
    id: "slapjs",
    label: "Slapjš",
}];

export class AddPropertyPartition extends React.Component<PropertyProps, AddPropertyPartitionState> {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            propertyData: {} as any,
            savingData: false,
            redirect: false,
        };
    }

    componentDidMount() {
        this.fetchPropertyData();
    }

    fetchPropertyData = () =>
        axios.get(`${process.env.baseUrl}/api/properties/${this.props.match.params.propertyId}`, {
            headers: {
                Authorization: Helpers.getSessionId(),
            },
        })
        .then(response => {
            this.setState({
                loaded: true,
                propertyData: response.data.data,
            });
        })
        .catch(_error => {
            this.setState({ loaded: true });
            Helpers.showError("Neizdevās ielādēt īpašuma datus!");
        })

    saveChanges = () => {
        this.setState({ savingData: true }, () => {
            axios.post(`${process.env.baseUrl}/api/properties/${this.props.match.params.propertyId}/partition`, {
                ...this.state.propertyData,
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            })
            .then(response => {
                if (response.data.success) {
                    this.setState({ savingData: false, redirect: true });
                } else {
                    Helpers.showError("Neizdevās saglabāt datus");
                }
            })
            .catch(_error => {
                Helpers.showError("Neizdevās saglabāt datus");
            });
        });
    }

    onValueChange = (field, value) => {
        const tempData = { ...this.state.propertyData } as any;
        tempData[field] = value;

        this.setState({ propertyData: tempData });
    }

    render() {
        const { propertyData } = this.state;
        const propertyId = this.props.match.params.propertyId;

        if (this.state.redirect) {
            return <Redirect to={`/ipasums/${propertyId}`}/>;
        }

        const pageContent = <ResponsiveElement desktopProps={{ size: "large" }} mobileProps={{ size: "huge" }}>
            <Form>
                <Grid>
                    <Grid.Row>
                        <Form.Field className="full--width">
                            <label>Zemes vienības numurs</label>
                            <input
                                type="number"
                                pattern="[0-9]*"
                                onChange={e => this.onValueChange("zmvs_kadnu", e.target.value)}
                            />
                        </Form.Field>
                    </Grid.Row>
                    <Grid.Row>
                        <Form.Field className="full--width">
                            <label>Nogabala numurs</label>
                            <input
                                type="number"
                                pattern="[0-9]*"
                                onChange={e => this.onValueChange("nogabals", e.target.value)}
                            />
                        </Form.Field>
                    </Grid.Row>
                    <Grid.Row>
                        <Form.Field className="full--width">
                            <label>Cirtes veids</label>
                            <select
                                 onChange={e => this.onValueChange("felling_type", e.target.value)}
                            >
                                {fellingTypes.map(fellingType => (
                                    <option key={fellingType.id} value={fellingType.id} { ...propertyData.felling_type === fellingType.id ? { selected: true } : {} }>{fellingType.label}</option>
                                ))}
                            </select>
                        </Form.Field>
                    </Grid.Row>
                    <Grid.Row>
                        <Form.Field className="full--width">
                            <label>Slapjš/Sauss</label>
                            <select
                                onChange={e => this.onValueChange("drought", e.target.value)}
                            >
                                {drought.map(reason => (
                                    <option key={reason.id} value={reason.id} { ...propertyData.drought === reason.id ? { selected: true } : {} }>{reason.label}</option>
                                ))}
                            </select>
                        </Form.Field>
                    </Grid.Row>
                    {this.state.propertyData.drought === "slapjs" && <Grid.Row>
                        <Form.Field className="full--width">
                            <label>Slapjš - Iemesls</label>
                            <select
                                onChange={e => this.onValueChange("wet_reason", e.target.value)}
                            >
                                {wetReasons.map(reason => (
                                    <option key={reason.id} value={reason.id} { ...propertyData.wet_reason === reason.id ? { selected: true } : {} }>{reason.label}</option>
                                ))}
                            </select>
                        </Form.Field>
                    </Grid.Row>}
                    <Grid.Row>
                        <Form.Field className="full--width">
                            <label>Taksācija pareiza?</label>
                            <SwitchSelect
                                onChange={e => this.onValueChange("is_taxation_correct", e.target.value)}
                                selected={propertyData.is_taxation_correct}
                            />
                        </Form.Field>
                    </Grid.Row>

                   <Grid.Row>
                        <Form.Field className="full--width">
                            <label>Taksācija - Iemesls</label>
                            <select
                                onChange={e => this.onValueChange("taxation_reason", e.target.value)}
                            >
                                {taxationReason.map(reason => (
                                    <option key={reason.id} value={reason.id} { ...propertyData.taxation_reason === reason.id ? { selected: true } : {} }>{reason.label}</option>
                                ))}
                            </select>
                        </Form.Field>
                    </Grid.Row>

                    <Responsive maxWidth={Responsive.onlyMobile.maxWidth} className="full--width">
                        <Divider />
                    </Responsive>

                    <Grid.Row>
                        <ResponsiveElement desktopProps={{ size: "large" }} mobileProps={{ size: "huge", style: { width: "100%" } }}>
                            <Button onClick={this.saveChanges} color="green" loading={this.state.savingData}>Saglabāt</Button>
                        </ResponsiveElement>
                    </Grid.Row>
                </Grid>
            </Form>
        </ResponsiveElement>;

        const backButton = <NavLink to={`/ipasums/${propertyId}`} className="ui icon left labeled button huge" style={{ color: "#fff" }}>
            <Icon name="angle left"/> Atpakaļ
        </NavLink>;

        return (
            <div>
                <header style={{ background: "#fff" }}>
                    <div className="layout-wrapper">
                        <HeaderMenu { ...this.props } mobileLogoReplace={backButton}/>

                        <Responsive as={Grid}>
                            <Grid.Row style={{ paddingTop: 20, paddingBottom: 0 }}>
                                <Responsive maxWidth={Responsive.onlyMobile.maxWidth} mobile={16} computer={16} textAlign="center" as={Grid.Column}>
                                    <Header as="h1" style={{ margin: "40px 0 15px 0" }}>
                                        Jauns nogabals
                                        <Header.Subheader>{propertyData && propertyData.felling_area_name}</Header.Subheader>
                                    </Header>
                                </Responsive>

                                <Responsive minWidth={Responsive.onlyTablet.minWidth} mobile={8} computer={8} textAlign="left" as={Grid.Column}>
                                    <Header as="h1">
                                        Jauns nogabals
                                        <Header.Subheader>{propertyData && propertyData.felling_area_name}</Header.Subheader>
                                    </Header>
                                </Responsive>
                            </Grid.Row>
                        </Responsive>
                    </div>
                </header>

                <div className="layout-wrapper">
                    {pageContent}
                </div>
            </div>
        );
    }
}
